import { getCookie, deleteCookie, buildRequest } from "./auth.js";
import UnauthorisedError from '../errors/UnauthorisedError.js';

export async function fetchFrames() {
    const url = `/Account/GetFramesList`;

    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch frames: ${response.status} ${response.statusText}`);
            }
        }

        const frames = await response.json();
        return frames;
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function fetchUserFrames(frameType = null) {
    let url = `/EndUser/GetFramesList`;

    if(frameType){
        url = `${url}?cFrameType=${frameType}`
    }


    try {
        const response = await buildRequest(url);

        if (!response.ok) {
            if (response.status === 401) {
                deleteCookie();
                throw new UnauthorisedError();
            }
            else {
                throw new Error(`Failed to fetch user frames: ${response.status} ${response.statusText}`);
            }
        }

        return await response.json();
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function deleteUserFrames(frameId) {
    const url = `/EndUser/DeleteFrame/${encodeURIComponent(frameId)}`;

    try {
        const response = await buildRequest(url, 'DELETE');
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to delete user frame: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to delete user frame: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function addUserFrames(email, frameId, frameName) {
    const url = `/EndUser/AddFrame`;
    const payload = {
        frameeaddress: email,
        frameselecpartcode: Number(frameId),
        framename: frameName,
        frameemployeetopayval: 0
    };

    try {
        const response = await buildRequest(url, 'POST', payload);
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to add lens tints cases to account: ${response.status} ${response.statusText} | ${data.detail || text}`);
                }
            }
            return data;
        } catch (err) {
            if (!response.ok) {
                if (response.status === 401) {
                    deleteCookie();
                    throw new UnauthorisedError();
                }
                else {
                    throw new Error(`Failed to add lens tints cases to account: ${response.status} ${response.statusText} | ${text}`);
                }
            }
        }
    } catch (error) {
        throw new Error(error.message);
    }
}